/**
 * Created with IntelliJ IDEA.
 * User: ffischer
 * Date: 23.04.13
 * Time: 14:27
 */

import { Constants_Offer } from "../Constants_Offer";
import { OfferDescriptionDictionary } from "../OfferDescriptionDictionary";
import { IOfferDescription } from "./IOfferDescription";

/**
 * This description defines if the offer has an auto accept (no user acception is needed)
 */
export class OfferDescriptionAutoAccept implements IOfferDescription {
    private _autoAccept: boolean;

    constructor(autoAccept: boolean = false) {
        this._autoAccept = autoAccept;
    }

    public get name(): string {
        return Constants_Offer.OFFER_AUTO_ACCEPT;
    }

    public registerOfferDescription(dictonary: OfferDescriptionDictionary): void {
        dictonary.addEntry(this.name, this);
    }

    public parseFromObjectParam(params: any): void {
        this._autoAccept = params;
    }

    public get autoAccept(): boolean {
        return this._autoAccept;
    }

    public dispose(): void {
    }
}
